import { render, staticRenderFns } from "./FooterAma.vue?vue&type=template&id=db425380&scoped=true&"
import script from "./FooterAma.vue?vue&type=script&lang=js&"
export * from "./FooterAma.vue?vue&type=script&lang=js&"
import style0 from "./FooterAma.vue?vue&type=style&index=0&id=db425380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db425380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db425380')) {
      api.createRecord('db425380', component.options)
    } else {
      api.reload('db425380', component.options)
    }
    module.hot.accept("./FooterAma.vue?vue&type=template&id=db425380&scoped=true&", function () {
      api.rerender('db425380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ama/FooterAma.vue"
export default component.exports